import { render } from "./EventsContent.vue?vue&type=template&id=44f1545a"
import script from "./EventsContent.vue?vue&type=script&lang=js"
export * from "./EventsContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__